<template>
  <div class="page-wrapper">
    <main>
      <div class="auth-wrapper">
        <SignInForm
          v-if="currentForm === FORMS.SIGN_IN"
          @recover-password="currentForm = FORMS.PASSWORD_RECOVERY"
        />
        <PasswordRestoreForm
          v-else
          @login-page="currentForm = FORMS.SIGN_IN"
        />
      </div>

    </main>

    <footer>© {{ year }} ProntoQ</footer>
  </div>
</template>

<script>
import PasswordRestoreForm from '../Auth/AuthPasswordRestoreForm';
import SignInForm from '../Auth/AuthSignInForm';

const FORMS = Object.freeze({
  'SIGN_IN': 'sign_in',
  'PASSWORD_RESTORE': 'password_restore'
});

export default {
  name: 'Auth',
  components: {
    SignInForm,
    PasswordRestoreForm
  },
  data() {
    return {
      FORMS: FORMS,
      currentForm: FORMS.SIGN_IN,
      year: new Date().getFullYear(),
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
}

::v-deep {
  h1 {
    font-weight: 400;
    font-size: 22px;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-size: 16px;
    margin-top: 8px;
    text-align: center;
    color: var(--label-secondary);
  }

  form {
    & > * {
      margin-top: 32px;
    }

    button {
      height: 40px;
      margin-top: 32px;
    }

    .input-wrapper {
      position: relative;

      i {
        color: var(--label-secondary);
        position: absolute;
        left: 4px;
        top: 50%;
        transform: translateY(-50%);

        &.password-visibility {
          right: 4px;
          left: auto;
          cursor: pointer;
        }
      }

      input {
        padding-left: 24px;
      }

      button {
        width: auto;
        position: absolute;
        top: 50%;
        transform: translate(calc(24px + 100%), -50%);
        right: 0;
        border: none;
        background: none;
        margin: 0;
        height: auto;
        font-size: 12px;
        font-weight: normal;
        color: var(--label-tetriary);
      }
    }
  }



  .auth-wrapper {
    margin-top: 21vh;
  }

  main {
    width: 268px;
    height: 100%;
  }

  footer {
    text-align: center;
    position: fixed;
    bottom: 0;
    padding: 24px 0;
    color: var(--label-tetriary);
  }

  @media (max-width: 425px) {
    form .input-wrapper button {
      transform: none;
      width: 100%;
      top: 50px;
    }
    form button {
      margin-top: 70px;
    }
  }
}

</style>
